import { useCrossProductUrlWrapper } from '@atlassiansox/analytics-cross-product-interaction-client';

import { fg } from '@atlaskit/platform-feature-flags';

import type { TownsquareApp } from '../types';

export const useGetCrossProductWrappedUrl = (
	bridge: string,
	url: string,
	app?: TownsquareApp,
): string => {
	const sourceApp = app ?? 'teams';
	const buildUrlWithAnalyticsParams = useCrossProductUrlWrapper({
		bridge,
		product: 'townsquare',
		subProduct: sourceApp,
	});

	return app !== undefined && app !== 'teams' && fg('townsquare_teams_cross_app_mau')
		? buildUrlWithAnalyticsParams(url)
		: url;
};
